'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(_ref) {
    var children = _ref.children,
        listClassName = _ref.listClassName;
    return _react2.default.createElement("div", null, _react2.default.createElement("ul", { className: (0, _classnames2.default)('luna-list', listClassName) }, children));
};
List.propTypes = {
    listClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
    children: _propTypes2.default.node.isRequired
};
exports.default = List;
//# sourceMappingURL=List.js.map